import {z} from '@hono/zod-openapi';

/** The service holding a Price Report. */
export const priceReportSourceSchema = z
  .enum(['metada', 'prompt-bridge'])
  .openapi('PriceReportSource');

export type PriceReportSource = z.infer<typeof priceReportSourceSchema>;
